module.exports = __webpack_public_path__ + "static/img/DoIt-01.0d31132.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/DoIt-01.png
// module id = J+tS
// module chunks = 0